import React from 'react';
import PropTypes from 'prop-types';

import { ImageFit } from '@fluentui/react/lib/Image';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { CircleLogo } from './circle-logo';
import { SmartImageConnector as SmartImage } from '../smart-image-connector';

// square image
const DefaultImageWidth = 48;
const SmallerImageWidth = 40;

const getStyles = (_, { palette = {} }) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  defaultImageContainer: {
    marginRight: 12,

    '& $imageComponentRoot': {
      width: DefaultImageWidth,
      height: DefaultImageWidth,
    },
  },
  smallerImageContainer: {
    marginRight: 12,

    '& $imageComponentRoot': {
      width: SmallerImageWidth,
      height: SmallerImageWidth,
    },
  },
  imageComponentRoot: {
    borderRadius: '50%',
    MozBorderRadius: '50%',
    WebkitBorderRadius: '50%',
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  label: {
    fontSize: 24,
    fontWeight: 'bold',
    lineHeight: '32px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    overflowWrap: 'break-word',
    color: palette.primaryText,
  },
  labelWithTimestamp: {
    fontSize: 14,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  timestamp: {
    fontSize: 12,
    color: '#605e5c',
  },
});

const UnStyledLogoImage = ({
  imageId,
  label,
  timestamp,
  classes,
  logoDataProperty,
  businessNameDataProperty,
}) => {
  let imageWidth = DefaultImageWidth;

  let imageContainerClassName = classes.defaultImageContainer;
  let labelClassName = classes.label;

  if (timestamp) {
    imageWidth = SmallerImageWidth;

    imageContainerClassName = classes.smallerImageContainer;
    labelClassName = classes.labelWithTimestamp;
  }

  return (
    <div className={classes.container}>
      <div className={imageContainerClassName} data-property={logoDataProperty}>
        {imageId && (
          <SmartImage
            imageId={imageId}
            imageFit={ImageFit.centerContain}
            maximizeFrame
            className={classes.imageComponentRoot}
            resizeWidth={imageWidth}
          />
        )
        }
        {!imageId && <CircleLogo name={label} className={classes.imageComponentRoot} />}
      </div>
      <div className={classes.infoContainer} >
        <span className={labelClassName} data-property={businessNameDataProperty} title={label}>
          {label}
        </span>
        {timestamp &&
          <span className={classes.timestamp}>{timestamp}</span>
        }
      </div>
    </div>
  );
};

UnStyledLogoImage.propTypes = {
  imageId: PropTypes.string,
  label: PropTypes.string.isRequired,
  timestamp: PropTypes.string,
  logoDataProperty: PropTypes.string,
  businessNameDataProperty: PropTypes.string,
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
  }).isRequired,
};

UnStyledLogoImage.defaultProps = {
  imageId: null,
  timestamp: null,
  logoDataProperty: null,
  businessNameDataProperty: null,
};

UnStyledLogoImage.displayName = 'LogoImage';

export const LogoImage = withDefaultStyles(UnStyledLogoImage, getStyles);
